import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8d344bfa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "campaign-complete",
  class: /*#__PURE__*/_normalizeClass({ portrait: true })
}
const _hoisted_2 = { id: "campaign-complete-media-container" }
const _hoisted_3 = { id: "campaign-complete-info-container" }
const _hoisted_4 = { id: "campaign-complete-info" }
const _hoisted_5 = { id: "campaign-complete-info-header" }
const _hoisted_6 = {
  id: "campaign-complete-info-header-title",
  "data-test": "claim-name"
}
const _hoisted_7 = { id: "campaign-complete-info-header-subtitle" }
const _hoisted_8 = ["data-wallet"]
const _hoisted_9 = ["data-creator-address"]
const _hoisted_10 = { id: "campaign-complete-info-summary-countdown-action" }

import ApproveSpendButton from '@/components/ApproveSpendButton.vue';
import BuyButton from '@/components/BuyButton.vue';
import ClaimDescription from '@/components/ClaimDescription.vue';
import ClaimSummary from '@/components/ClaimSummary.vue';
import Countdown from '@/components/Countdown.vue';
import Frame from '@/components/Frame.vue';
import ImageLoader from '@/components/ImageLoader.vue';
import PlatformLinks from '@/components/PlatformLinks.vue';
import Provenance, { Record } from '@/components/Provenance.vue';
import WalletConnection from '@/components/WalletConnection.vue';
import {
  abbreviate,
  abbreviateAddress
} from '@/lib/claimUtil';
import { useClaimStore } from '@/store/claimStore';
import ViewOriginalMedia from './ViewOriginalMedia.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ClaimCompleteBody',
  setup(__props) {

const store = useClaimStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Frame, _mergeProps({
    id: "campaign-complete-frame",
    class: "m-project"
  }, _ctx.$attrs), {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(WalletConnection, {
          id: "campaign-complete-wallet",
          "fallback-provider": _unref(store).fallbackProvider
        }, null, 8, ["fallback-provider"]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(ImageLoader, {
            id: "campaign-complete-media",
            image: _unref(store).image,
            media: _unref(store).animation ?? _unref(store).tokenUrl ?? null,
            "arweave-url": _unref(store).arweaveURL ?? null,
            onChainImage: _unref(store).onChainImage ?? null
          }, {
            error: _withCtx(() => [
              _createTextVNode(" Failed to load the image ")
            ]),
            _: 1
          }, 8, ["image", "media", "arweave-url", "onChainImage"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h1", _hoisted_6, _toDisplayString(_unref(store).name), 1),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", {
                  id: "campaign-complete-info-header-artist",
                  "data-widget": "m-wallet-identity",
                  class: "manifold-scheme-dark",
                  "data-wallet": _unref(store).creator.address
                }, null, 8, _hoisted_8),
                _createElementVNode("div", {
                  id: "campaign-complete-info-header-subscribe",
                  "data-widget": "m-widget-subscribe",
                  "data-creator-address": _unref(store).creator?.address
                }, null, 8, _hoisted_9)
              ])
            ]),
            _createVNode(ClaimDescription, {
              id: "campaign-complete-info-description",
              description: _unref(store).description
            }, null, 8, ["description"]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(ClaimSummary, {
                id: "campaign-complete-info-summary",
                total: _unref(store).total,
                "total-max": _unref(store).totalMax,
                cost: _unref(store).cost,
                "has-allowlist": _unref(store).hasAllowlist,
                "erc-twenty-symbol": _unref(store).erc20Symbol,
                "erc-twenty-decimals": _unref(store).erc20Decimals
              }, null, 8, ["total", "total-max", "cost", "has-allowlist", "erc-twenty-symbol", "erc-twenty-decimals"]),
              (_unref(store).status === 'active' && _unref(store).endDate && !_unref(store).isSoldOut)
                ? (_openBlock(), _createBlock(Countdown, {
                    key: 0,
                    id: "campaign-complete-info-countdown",
                    "end-date": _unref(store).endDate
                  }, null, 8, ["end-date"]))
                : _createCommentVNode("", true),
              (_unref(store).erc20Address && _unref(store).erc20ApprovedSpend.lt(_unref(store).cost))
                ? (_openBlock(), _createBlock(ApproveSpendButton, { key: 1 }))
                : (_openBlock(), _createBlock(BuyButton, {
                    key: 2,
                    id: "campaign-buy-button"
                  }))
            ]),
            _createVNode(Provenance, {
              id: "campaign-complete-info-details",
              records: ([
                        //TODO: make storageprotocol aware
                        _unref(store).arweaveURL ? {
                          label: 'Arweave URL',
                          link: _unref(store).arweaveURL,
                          value: _unref(abbreviate)(_unref(store).arweaveURL.split('/').pop()!)
                        } : undefined,
                        {
                          label: 'Contract Address',
                          link: `https://etherscan.io/address/${_unref(store).creatorContractAddress}`,
                          value: _unref(abbreviateAddress)(_unref(store).creatorContractAddress)
                        },
                        _unref(store).claimType ? {
                          label: 'Token Standard',
                          value: _unref(store).claimType.toUpperCase()
                        } : undefined,
                        {
                          label: 'Blockchain',
                          value: 'Ethereum'
                        },
                        _unref(store).startDate ? {
                          label: 'Start Date',
                          value: _unref(store).startDate.toISOString().slice(0, 10)
                        } : undefined,
                        _unref(store).endDate ? {
                          label: 'End Date',
                          value: _unref(store).endDate.toISOString().slice(0, 10)
                        } : undefined
                      ].filter(Boolean) as Record[])
            }, null, 8, ["records"]),
            _createVNode(PlatformLinks, {
              id: "campaign-complete-info-platform-links",
              is1155: _unref(store).is1155,
              "has-mints": _unref(store).total > 0,
              "creator-contract-address": _unref(store).creatorContractAddress,
              "token-id": _unref(store).tokenId === null ? undefined : _unref(store).tokenId
            }, null, 8, ["is1155", "has-mints", "creator-contract-address", "token-id"]),
            (_unref(store).arweaveURL)
              ? (_openBlock(), _createBlock(ViewOriginalMedia, {
                  key: 0,
                  "arweave-url": _unref(store).arweaveURL ?? null
                }, null, 8, ["arweave-url"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _: 1
  }, 16))
}
}

})